import React, { useEffect, useState } from 'react';

import { ReactComponent as IconChat } from '@skippay/core/assets/icons/heroIcons/Chat.svg';
import Link from '@skippay/core/components/Link';
import useInitialCountryLocale from '@skippay/core/hooks/useInitialCountryLocale';
import useUserCountryRelatedInfo from '@skippay/core/hooks/useUserCountryRelatedInfo';
import { isInPopUpBrowser } from '@skippay/core/modules/clientInfo';

import { ROUTES } from 'constants/routes';

const PAGE_TYPE_SELF_CARE = 'self-care';
const PAGE_TYPE_WEB = 'web';

export const pageTypePropsConfig = {
	// Self-care and /login chat after 10 seconds
	[PAGE_TYPE_SELF_CARE]: { timeout: 10000 },
	// All page except /login, chat after 5 seconds
	[PAGE_TYPE_WEB]: { timeout: 5000 },
};

interface Props {
	pageType?: 'self-care' | 'web';
}

// Daktela is deprecated for now. When JaraBot is stable, we can remove this component completely.
function DaktelaCustomerChat(props: Props) {
	const [initialized, setInitialized] = useState(false);
	const { locale } = useInitialCountryLocale();
	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (!initialized) {
			const timeoutFallback = 5000;
			const timeout = props.pageType
				? pageTypePropsConfig[props.pageType].timeout || timeoutFallback
				: timeoutFallback;

			const timerId = setTimeout(() => {
				setInitialized(true);
			}, timeout);
			return () => window.clearTimeout(timerId);
		}
	}, []);

	if (initialized) {
		return (
			<Link
				data-daktela-chat
				analyticsId="daktelaChat"
				testId="daktelaChat"
				to={`${ROUTES(locale).contacts}#openChat`}
				isExternal
				className="fixed right-6 bottom-6 z-50 flex h-12! w-12! cursor-pointer items-center justify-center rounded-full
					bg-blue-500! shadow-lg transition-transform hover:scale-95"
			>
				<div className="absolute top-1 left-1 h-3 w-3 rounded-full bg-green-400" />
				<IconChat className="h-7 w-7 text-white" />
			</Link>
		);
	}

	return null;
}

function DaketelaCustomeChatWrapper(props: Props) {
	const { country } = useUserCountryRelatedInfo();

	if (isInPopUpBrowser() || country !== 'CZ') {
		return null;
	}

	const MemoComponent = React.memo(DaktelaCustomerChat);

	return <MemoComponent {...props} />;
}

// process.env.NODE_ENV !== 'development' &&
export default typeof window !== 'undefined' && !process.env.MOB_APP_BUILD
	? DaketelaCustomeChatWrapper
	: () => null;
